import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BRAND_CONTEXT_CATEGORIES } from "@/types/brand-context";

interface CategorySelectProps {
  value: string;
  onValueChange: (value: string) => void;
  includeAllOption?: boolean;
  className?: string;
}

export function CategorySelect({ value, onValueChange, includeAllOption = false, className }: CategorySelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder="Select category" />
      </SelectTrigger>
      <SelectContent className="bg-popover border border-border">
        {includeAllOption && <SelectItem value="all">All Categories</SelectItem>}
        {BRAND_CONTEXT_CATEGORIES.map((cat) => (
          <SelectItem key={cat} value={cat}>
            {cat}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
